var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9C21.8807 9 23 7.88071 23 6.5C23 5.11929 21.8807 4 20.5 4C19.1193 4 18 5.11929 18 6.5C18 7.88071 19.1193 9 20.5 9Z",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25L10.1375 9.46249C10.2281 9.31513 10.3549 9.19345 10.5059 9.10904C10.6569 9.02463 10.827 8.98032 11 8.98032C11.173 8.98032 11.3431 9.02463 11.4941 9.10904C11.6451 9.19345 11.7719 9.31513 11.8625 9.46249L21 25H1Z",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 16H15.6998",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19L21.1377 12.9499C21.2283 12.8026 21.3551 12.6809 21.5061 12.5965C21.6571 12.5121 21.8272 12.4678 22.0002 12.4678C22.1732 12.4678 22.3433 12.5121 22.4943 12.5965C22.6452 12.6809 22.7721 12.8026 22.8627 12.9499L28 21.5",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 4.5,
    stroke: "#444F60",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 24.0004V27.0004",
    stroke: "#444F60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.3646L25.5 27.001L27 25.3646",
    stroke: "#444F60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHightDown);
export default __webpack_public_path__ + "static/media/Hight_Down.a1e421cf559477cf80fda78759093ed0.svg";
export { ForwardRef as ReactComponent };